import React from 'react';
import PropTypes from 'prop-types';

export class Card extends React.Component {
    static propTypes = {
        logo: PropTypes.object.isRequired,
        url: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
    };
    render() {
        const { logo, url, title } = this.props;
        return (
            <div className="col-md-4">
                <div className="card">
                    <div className="card-img-top">
                        <img src={logo} alt="34aLogo"/>
                    </div>
                    <div className="card-body">
                        <h5 className="card-title">{title}</h5>
                        <a href={url} target="_blank" className="btn btn-primary">
                            <span>Zum Shop</span>
                        </a>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/features/products/Card.js